<template>

    <v-dialog
        v-model="setting.is_show"
        :width="setting.width"
        @click:outside="close"
    >
        <v-card
            :style="{
                position: 'relative'
            }"
        >
            <span
                :style="{
                    display: 'block',
                    width: '30px',
                    height: '30px',
                    lineHeight: '30px',
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    cursor: 'pointer'
                }"
                @click="close"
            >
                <v-icon>
                    mdi-close
                </v-icon>
            </span>

            <slot name="card-title">
                <v-card-title
                    class="card-title"
                >
                {{setting.title}}
                </v-card-title>
            </slot>    
        
            <v-card-subtitle
                class="card-subtitle"
                v-if="setting.subtitle"
            >{{setting.subtitle}}</v-card-subtitle>

            <v-card-subtitle
                class="card-subtitle"
                v-if="setting.description"
                :style="{
                }"
            >{{setting.description}}</v-card-subtitle>
            
            <div
              :style="{
                position: 'relative',
                overflowX: 'auto',
                maxWidth: '800px'
              }"
            >
              <v-textarea
                ref="body_script"
                :value="`${setting.html_code}`"
                no-resize
                readonly
                outlined
                name="input-7-4"
                :style="{
                  padding: '0px 24px 0px',
                  borderColor: '#dadce0',
                  borderRadius: '4px',
                  height: 'auto',
                  margin: '0',
                  minHeight: '50px',
                  verticalAlign: 'top',
                  fontFamily: 'courier new,courier,monospace',
                  fontSize: '12px',
                  maxWidth: '800px',
                  overflow: 'auto'
                }"
                color="primary"
              ></v-textarea>
              <button
                @click="copyContent"
                :style="{
                  position: 'absolute',
                  top: '15px',
                  right: '40px',
                  cursor: 'pointer',
                }"
              >
                <v-icon
                >
                  mdi-clipboard-multiple-outline
                </v-icon>
              </button>
            </div>

        </v-card>

    </v-dialog>

</template>

<script>
    export default {
        name: 'CodeCopyDialog',
        props: {
            setting: Object
        },
        data() {
            return {
                show: true
            }
        },
        created() {
            
        },
        mounted() {
        },
        computed: {

        },
        destroyed() {

        },
        methods: {
            close: function(){
                this.setting.is_show = false
            },
            copyContent: function(){
                console.log(this.setting.html_code)
                navigator.clipboard.writeText(this.setting.html_code);
                this.$root.vtoast.show({ 
                    message: "已複製到剪貼簿🎉🎉，貼到您的網站中就可以囉！"
                }) 
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
.card-title {
    font-size: 16px !important;
}
.card-subtitle {
    font-size: 14px !important;
    padding: 5px 0px 5px 24px !important;
}
</style>